import React from 'react';
import { useIntl } from 'react-intl';
import Select, { SelectOption } from '@amzn/meridian/select';
import { getLanguageName } from './helper';
import moment from 'moment';

interface CatalogFilterProps {
  filterLabel: string;
  value: string;
  setValue: any;
  selections: string[];
  isLanaguageCode?: boolean;
  isDuration?: boolean;
}

const CatalogFilter: React.FC<CatalogFilterProps> = ({
  filterLabel,
  value,
  setValue,
  selections,
  isLanaguageCode = false,
  isDuration = false,
}) => {
  const intl = useIntl();
  return (
    <Select label={filterLabel} value={value} onChange={setValue} width={300}>
      {isLanaguageCode
        ? selections.map(selection => (
            <SelectOption
              value={selection}
              label={getLanguageName(intl, selection)}
            />
          ))
        : isDuration
          ? selections.map(selection =>
              selection === 'ALL' ? (
                <SelectOption
                  value={selection}
                  label={intl.formatMessage({
                    id: 'cs_perf_portal_training_catalog_selection_all',
                    defaultMessage: 'All',
                  })}
                />
              ) : (
                <SelectOption
                  value={selection}
                  label={intl.formatMessage(
                    {
                      id: 'cs_perf_portal_training_catalog_min',
                      defaultMessage: '{num} min',
                    },
                    { num: moment.duration(selection).asMinutes() }
                  )}
                />
              )
            )
          : selections.map(selection =>
              selection === 'ALL' ? (
                <SelectOption
                  value={selection}
                  label={intl.formatMessage({
                    id: 'cs_perf_portal_training_catalog_selection_all',
                    defaultMessage: 'All',
                  })}
                />
              ) : (
                <SelectOption value={selection} label={selection} />
              )
            )}
    </Select>
  );
};

export default CatalogFilter;
